import styled from 'styled-components';

const shouldForwardInnerProp = (prop) => !['isRightAligned'].includes(prop);

export const Container = styled.div`
    left: 0;
    right: 0;
    height: 0;
    pointer-events: none;
    z-index: 2;
    bottom: 100px;
    margin-top: 24px;
    position: -webkit-sticky;
    position: sticky;
`;
export const Inner = styled.div.withConfig({ shouldForwardProp: shouldForwardInnerProp })`
    justify-content: ${(props) => (props.isRightAligned ? 'flex-end' : 'center')};
    display: flex;
`;
